<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Dashboard</h1>
            </div>
            <!-- /.col -->
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                    <li class="breadcrumb-item active">Dashboard</li>
                </ol>
            </div>
            <!-- /.col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</div>
<!-- /.content-header -->

<!-- Main content -->
<section class="content">
    <div class="container-fluid" *ngIf="dataDashboard">
        <!-- Small boxes (Stat box) -->
        <div class="row justify-content-center">
            <div [ngClass]="this.appService.user.role == 'user' ? 'col-lg-3 col-12' : 'col-lg-6 col-12'" *ngIf="this.appService.user.role != 'delivery'">
                <div class="row justify-content-center">
                    <div [ngClass]="this.appService.user.role == 'user' ? 'col-lg-12 col-sm-6 col-12' : 'col-sm-6 col-12'">
                        <div class="small-box bg-info">
                            <div class="inner">
                                <h3>{{dataDashboard.pedidos}} <sup style='font-size: 20px'
                                        *ngIf="this.appService.user.role == 'admin' || this.appService.user.role == 'superadmin'">{{dataDashboard.total_venta_pedidos}}</sup>
                                </h3>
                                <p>Pedidos del mes</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-boxes"></i>
                            </div>
                            <a [routerLink]="'/pedidos-todos'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6 col-12"
                        *ngIf="this.appService.user.role == 'admin' || this.appService.user.role == 'superadmin'">
                        <div class="small-box bg-success">
                            <div class="inner">
                                <h3>{{dataDashboard.ingresosMes}}</h3>
                                <p>Ingresos del mes</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-dollar-sign"></i>
                            </div>
                            <a [routerLink]="'/pedidos-todos'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div [ngClass]="this.appService.user.role == 'user' ? 'col-lg-12 col-sm-6 col-12' : 'col-sm-6 col-12'">
                        <div class="small-box bg-info">
                            <div class="inner">
                                <h3>{{dataDashboard.pedidos_hoy}} <sup style='font-size: 20px'
                                        *ngIf="this.appService.user.role == 'admin' || this.appService.user.role == 'superadmin'">{{dataDashboard.total_venta_hoy}}</sup>
                                </h3>
                                <p>Pedidos del día</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-box"></i>
                            </div>
                            <a [routerLink]="'/pedidos-hoy'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6 col-12"
                        *ngIf="this.appService.user.role == 'admin' || this.appService.user.role == 'superadmin'">
                        <div class="small-box bg-success">
                            <div class="inner">
                                <h3>{{dataDashboard.ingreso}}</h3>
                                <p>Ingresos del día</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-dollar-sign"></i>
                            </div>
                            <a [routerLink]="'/pedidos-hoy'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div [ngClass]="this.appService.user.role == 'delivery' ? 'col-12' : 'col-lg-6 col-12'">
                <div class="row justify-content-center">
                    <div class="col-sm-6 col-12" *ngIf="this.appService.user.role != 'delivery'">
                        <div class="small-box bg-danger">
                            <div class="inner">
                                <h3>{{dataDashboard.impagos}} <sup style='font-size: 20px'
                                        *ngIf="this.appService.user.role == 'admin' || this.appService.user.role == 'superadmin'">{{dataDashboard.deuda}}</sup>
                                </h3>
                                <p>Pedidos entregados pendientes de pago</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-hand-holding-usd"></i>
                            </div>
                            <a [routerLink]="'/clientes-deudores'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6 col-6" *ngIf="this.appService.user.role != 'delivery'">
                        <div class="small-box bg-primary">
                            <div class="inner">
                                <h3>{{dataDashboard.clientes}}</h3>
                                <p>Clientes</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-users"></i>
                            </div>
                            <a [routerLink]="'/clientes'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4 col-6" *ngIf="this.appService.user.role != 'delivery'">
                        <div class="small-box bg-warning">
                            <div class="inner">
                                <h3>{{dataDashboard.entregas}}</h3>
                                <p>Entregas para hoy</p>
                            </div>
                            <div class="icon">
                                <i class="fab fa-black-tie"></i>
                            </div>
                            <a [routerLink]="'/pedidos-hoy'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div
                        [ngClass]="this.appService.user.role == 'delivery' ? 'col-sm-6 col-12' : 'col-sm-4 col-6'">
                        <div class="small-box bg-warning">
                            <div class="inner">
                                <h3 class="supsub">{{dataDashboard.retiros}}</h3>
                                <p>Retiros Pendientes</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-shipping-fast"></i>
                            </div>
                            <a [routerLink]="'/pedidos-delivery'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div
                        [ngClass]="this.appService.user.role == 'delivery' ? 'col-sm-6 col-12' : 'col-sm-4 col-6'">
                        <div class="small-box bg-warning">
                            <div class="inner">
                                <h3 class="supsub">{{dataDashboard.despachos}}</h3>
                                <p>Despachos Pendientes</p>
                            </div>
                            <div class="icon">
                                <i class="fas fa-shipping-fast"></i>
                            </div>
                            <a [routerLink]="'/pedidos-delivery'" class="small-box-footer">
                                Ver más <i class="fas fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.row -->
        <div class="row" *ngIf="this.appService.user.role == 'admin' || this.appService.user.role == 'superadmin'">
            <div class="col-lg-8">
                <div class="card card-dark">
                    <div class="card-header border-0">
                        <div class="d-flex justify-content-between">
                            <h3 class="card-title">Ingresos y pedidos del mes</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <div id="pie-chart-parent">
                            <ngx-charts-line-chart [scheme]="colorScheme" [legend]="showLegend"
                                [legendTitle]="'Leyenda'" [showXAxisLabel]="showXAxisLabel"
                                [showYAxisLabel]="showYAxisLabel" [xAxis]="showXAxis" [yAxis]="showYAxis"
                                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                                [yAxisTickFormatting]="yAxisTickFormatting" [timeline]="timeline"
                                [results]="graficoVenta" (select)="onSelect($event)" (activate)="onActivate($event)"
                                (deactivate)="onDeactivate($event)">
                                <ng-template #tooltipTemplate let-model="model">
                                    {{ model.series }} • {{ model.name }}: {{ Func.currencyPeso(model.value) }}
                                </ng-template>
                                <ng-template #seriesTooltipTemplate let-model="model">
                                    <div *ngFor="let item of model" class="tooltip-item">
                                        {{ item.series }} • {{ item.name }}: {{ Func.currencyPeso(item.value) }}
                                    </div>
                                </ng-template>
                            </ngx-charts-line-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card card-dark">
                    <div class="card-header border-0">
                        <div class="d-flex justify-content-between">
                            <h3 class="card-title">Productos top ventas mes actual</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <div id="pie-chart-parent">
                            <ngx-charts-pie-chart [scheme]="colorSchemeBlue" [results]="GraficoTopVentasActual"
                                [gradient]="false" [legend]="false" [legendPosition]="legendPosition" [maxLabelLength]="15"
                                [labels]="true" [doughnut]="false" [tooltipText]="pieTooltipText"
                                (select)="onSelect($event)" (activate)="onActivate($event)"
                                (deactivate)="onDeactivate($event)">
                            </ngx-charts-pie-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card card-dark">
                    <div class="card-header border-0">
                        <div class="d-flex justify-content-between">
                            <h3 class="card-title">Productos top ventas mes anterior</h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <div id="pie-chart-parent">
                            <ngx-charts-pie-chart [scheme]="colorSchemeBlue" [results]="GraficoTopVentasAnterior"
                                [gradient]="false" [legend]="false" [legendPosition]="legendPosition" [maxLabelLength]="15"
                                [labels]="true" [doughnut]="false" [tooltipText]="pieTooltipText"
                                (select)="onSelect($event)" (activate)="onActivate($event)"
                                (deactivate)="onDeactivate($event)">
                            </ngx-charts-pie-chart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="card card-dark">
                    <div class="card-header border-0">
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <h3 class="card-title mb-0">Ingresos del mes actual x anterior</h3>
                            <div class="d-flex align-items-center mxm-range" *ngIf="diasMxM.length">
                                <label class="mb-0 mr-1">Del</label>
                                <select class="form-control form-control-sm mxm-day" [(ngModel)]="diaDesdeMxM"
                                    (ngModelChange)="onRangoMxMChange()">
                                    <option *ngFor="let dia of diasMxM" [value]="dia">{{ dia }}</option>
                                </select>
                                <label class="mb-0 mx-1">al</label>
                                <select class="form-control form-control-sm mxm-day" [(ngModel)]="diaHastaMxM"
                                    (ngModelChange)="onRangoMxMChange()">
                                    <option *ngFor="let dia of diasMxM" [value]="dia">{{ dia }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="mxm-totales mb-3">
                            <span class="badge badge-info mr-2">
                                Actual: {{ Func.currencyPeso(totalMxMActual) }}
                            </span>
                            <span class="badge badge-secondary mr-2">
                                Anterior: {{ Func.currencyPeso(totalMxMAnterior) }}
                            </span>
                            <span class="badge badge-dark">
                                Diff: {{ Func.currencyPeso(totalMxMActual - totalMxMAnterior) }}
                            </span>
                        </div>
                        <div id="pie-chart-parent">
                            <ngx-charts-line-chart [scheme]="colorScheme" [legend]="showLegend"
                                [legendTitle]="'Leyenda'" [showXAxisLabel]="showXAxisLabel"
                                [showYAxisLabel]="showYAxisLabel" [xAxis]="showXAxis" [yAxis]="showYAxis"
                                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                                [yAxisTickFormatting]="yAxisTickFormatting" [timeline]="timeline"
                                [results]="graficoVentaMxM" (select)="onSelect($event)" (activate)="onActivate($event)"
                                (deactivate)="onDeactivate($event)">
                                <ng-template #tooltipTemplate let-model="model">
                                    {{ model.series }} • {{ model.name }}: {{ Func.currencyPeso(model.value) }}
                                </ng-template>
                                <ng-template #seriesTooltipTemplate let-model="model">
                                    <div *ngFor="let item of model" class="tooltip-item">
                                        {{ item.series }} • {{ item.name }}: {{ Func.currencyPeso(item.value) }}
                                    </div>
                                </ng-template>
                            </ngx-charts-line-chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Main row -->
</section>
<!-- /.content -->